import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AppRoutes } from './router'
import { useEffect } from 'react'
import { LayoutDataProvider } from './contexts/LayoutDataContext'

function App() {
  useEffect(() => {
    // Disable browser scroll restoration globally
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Toaster
        position="top-center"
        containerStyle={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        toastOptions={{ duration: 4000 }}
      />
      <LayoutDataProvider>
        <AppRoutes />
      </LayoutDataProvider>
    </BrowserRouter>
  )
}

export default App